export default __webpack_public_path__ + "static/media/warri-terminal.56b9f763.png";